import { CONFIG_URL } from '../helpers/constants'

const api = {
   URI_ENDPOINT: CONFIG_URL.SERVICE_URL,
   auth: {
      refreshToken: '/auth/refresh-tokens',
      login: '/auth/login', // API I: API Signin
      register: '/auth/register',
      getUserInfo: '/auth/getUserInfo',
      updateInfo: '/auth/updateInfo',
      changePassword: '/auth/changePassword',
      resetPassword: '/auth/reset-password',
      forgotPassword: '/auth/forgot-password',
      logout: '/sign-out', // API II: API SignOut
      verifyEmail: '/auth/verify-email',
      sendEmail: '/auth/send-verification-email'
   },
   upload: {
      uploadFile: '/upload',
      getUploadUrl: '/file/upload', // API III: API lấy preSignedUrl upload file
      getViewUrl: '/file/retrieve', // API IV: API lấy preSignedUrl view file
      remove: '/file/remove' // API: API xoá file upload
   },

   user: {
      getDropdownUsername: '/user/dropdown-username', // API XXVII: API lấy dropdown hiển thị tất cả username đang hoạt động
      getProfile: '/profiles', // API XII: API lấy thông tin user info
      updateProfile: '/profiles',
      changePassword: '/profiles/change-password',
      transaction: '/profiles/transaction'
   },

   promotions: {
      getList: '/promotions',
      create: '/promotions',
      update: '/promotions',
      delete: '/promotions'
   },
   provinces: {
      default: '/provinces/default',
      getList: '/provinces/search',
      create: '/provinces',
      update: '/provinces',
      delete: '/provinces'
   },
   districts: {
      getList: '/districts/search',
      create: '/districts',
      update: '/districts',
      delete: '/districts'
   },
   prices: {
      getList: '/route-prices/active',
      update: '/route-prices/'
   },

   managerUser: {
      getUser: '/users',
      create: '/users',
      update: '/users',
      delete: '/users',
      transaction: '/users/transaction'
   },
   config: {
      create: '/config',
      update: '/config',
      getList: '/config',
      getListSupport: '/config/get-link-support'
   },
   debt: {
      getList: '/debts',
      total: 'debts/total'
   },
   funds: {
      create: '/funds',
      update: '/funds',
      approve: '/funds/approve',
      getList: '/funds',
      total: '/funds/total'
   },
   notification: {
      get: '/notifications',
      mark_read: '/notifications/mark-read'
   },
   order: {
      getOrders: '/orders',
      create: '/orders',
      update: '/orders',
      cancel: '/orders/:id/cancel',
      delete: '/orders'
   },
   // ===== ORDER WEB (mapping từ mobile app) =====
   order_web: {
      createForGuest: 'orders/createForGuest',
      listByUser: '/orders/my-orders',
      listByDriver: '/orders/orders-by-driver',

      detail: '/orders/:id',
      create: '/orders',
      update: '/orders/:id',

      cancel: '/orders/my-orders/:id/cancel',

      previewPrice: '/orders/calculator-price',

      shareTrip: '/orders/:id/share',
      assignDriver: '/orders/:id/assign-driver',
      startTrip: '/orders/:id/start-trip',
      completeTrip: '/orders/:id/complete'
   },
   trips: {
      list: '/route-prices/province',
      detail: 'route-prices/by-route',
      create: 'orders',
      shareTrip: 'orders/:id/share',
      receiverTrip: 'orders/:id/assign-driver',
      startTrip: 'orders/:id/start-trip',
      complete: 'orders/:id/complete',
      previewOrder: 'orders/calculator-price',
      cancel: 'orders/my-orders/:id/cancel',
      cancelShare: 'orders/:id/cancel-share'
   },
   routePrice: {
      getRoute: 'route-prices/active'
   },
   dashboard: {}
}

export default api
